(function() {
	'use strict';

	angular.module('quantixApp').factory('UsageTrackerService',
			UsageTrackerService);

	UsageTrackerService.$inject = [ '$resource','$http','$q' ];

	function UsageTrackerService($resource,$http,$q) {

		
		var _getUsageTrackerData = function(fd) {
         	var deferred = $q.defer();
			var url = 'api/userTracker/getUsageTrackerList';

			$http.post(url,fd,{
				transformRequest : angular.identity,
				headers : {
					'Content-Type' : undefined,
				}
			}).then(function(response) {

				deferred.resolve(response.data);

			}, function(errResponse) {
				deferred.reject(errResponse);
			});

			return deferred.promise; 
			}
		var _getUsersList = function() {

			var deferred = $q.defer();
			var url = 'api/userTracker/getUsersList';

			$http.post(url).then(function(response) {

				deferred.resolve(response.data);

			}, function(errResponse) {
				deferred.reject(errResponse);
			});

			return deferred.promise;
			}
		var _IpcheckUpdate = function(user) {

			var deferred = $q.defer();
			var url = 'api/userTracker/IpcheckUpdate';

			$http.post(url,user).then(function(response) {

				deferred.resolve(response.data);

			}, function(errResponse) {
				deferred.reject(errResponse);
			});

			return deferred.promise;
			}
		
	
		return {
			getUsageTrackerData : _getUsageTrackerData,
			getUsersList:_getUsersList,
			IpcheckUpdate:_IpcheckUpdate
		
		};
	}
})();
